/**
 * Servizio per gestire lo stato di risoluzione delle discrepanze per container
 * Usa localStorage per persistenza semplice
 */

const STORAGE_KEY_PREFIX = 'container_triage_resolved_';

/**
 * Verifica se un container ha risolto tutte le discrepanze
 */
export const isContainerResolved = (containerId: string): boolean => {
    if (typeof window === 'undefined') return false;
    const key = `${STORAGE_KEY_PREFIX}${containerId}`;
    const value = localStorage.getItem(key);
    return value === 'true';
};

/**
 * Imposta lo stato di risoluzione per un container
 */
export const setContainerResolved = (containerId: string, resolved: boolean): void => {
    if (typeof window === 'undefined') return;
    const key = `${STORAGE_KEY_PREFIX}${containerId}`;
    if (resolved) {
        localStorage.setItem(key, 'true');
    } else {
        localStorage.removeItem(key);
    }
};

/**
 * Resetta lo stato di risoluzione per un container (rimuove dal localStorage)
 */
export const resetContainer = (containerId: string): void => {
    setContainerResolved(containerId, false);
};

